module.exports = __webpack_public_path__ + "static/media/header.6d7c02f7.jpg";